import { render } from "./NewExpenseView.vue?vue&type=template&id=e4f6b5fe"
import script from "./NewExpenseView.vue?vue&type=script&lang=js"
export * from "./NewExpenseView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__